import DealWithPublishError from '@quickService/DashboardEventDealWithPublishError';
import DashboardEventGetPublishErrorList, {
  Items,
} from '@quickService/DashboardEventGetPublishErrorList';
import DashboardEventGetProgressOfModule, {
  Data,
} from '@quickService/DashboardEventGetProgressOfModule';
import DashboardEventBriefInfo, {
  EventInfo,
  PublishedEventInfo,
} from '@quickService/DashboardEventBriefInfo';
import LobbyUserGetUserAuthority, {
  Data as UserAuthorityData,
} from '@quickService/LobbyUserGetUserAuthority';
import DashboardEventGetModules from '@quickService/DashboardEventGetModules';
import { ReactNode, useReducer, createContext, useContext, FC, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import useDebounce from 'src/hooks/useDebounce';
import { ROLETYPE } from '@utils/browser/app-context';
import { message } from '@tencent/tea-component';
import { ErrorType } from '@component/ErrorCenter';
import { getHostDetail, HostDetailData } from 'src/model/host-account';
const GetPublishErrorList = useDebounce(DashboardEventGetPublishErrorList);
interface StateProps extends EventPrograssProps {
  // 报错数据
  errorInfo: Items;
  warnItems: Items;
  showErrorCenter: boolean;
  showPublishTip: boolean;
  showCanPublishTip: boolean;
  showPublishDialog: boolean;
  loadingVisible: boolean;
  showPublishChangeDialog: boolean;
  dispatch: Function;
  userAuthority?: UserAuthorityData;
  handleError: Function;
  coverInfo: {
    cover_cos_id: string;
    cover_url: string;
  };
  hostDetail: HostDetailData;
  closePublishTip: (showPublishTip: boolean, showCanPublishTip: boolean) => void;
  publishedEventInfo?: PublishedEventInfo;
  errorItemsSort?: number;
}
const defaultProgressList = [
  { name: 'basic' },
  { name: 'guest' },
  { name: 'scheduler' },
  { name: 'ticket' },
  { name: 'register' },
  { name: 'publish' },
];
const defaultAdvancedList = [
  { name: 'register_question' },
  { name: 'approval' },
  { name: 'marketing' },
];
const defaultProgressInfo = {
  b_edit_attendee: false,
  b_edit_basic: false,
  b_edit_guest: false,
  b_edit_replay: false,
  b_edit_register_config: false,
  b_edit_ticket: false,
  b_edit_scheduler: false,
  b_edit_venue: true,
  wait_approving_num: 0,
};
const initialState: StateProps = {
  errorInfo: [],
  warnItems: [],
  showErrorCenter: false,
  showPublishTip: false,
  showCanPublishTip: false,
  showPublishDialog: false,
  loadingVisible: false,
  showPublishChangeDialog: false,
  eventInfo: {
    event_id: '',
    reedit_status: 0,
  },
  coverInfo: {
    cover_cos_id: '',
    cover_url: '',
  },
  progressList: [],
  progressInfo: {},
  advancedList: [],
  dispatch: () => {},
};
/** 活动进度数据 */
interface ObjectString extends Data {
  [key: string]: any;
}
interface EventPrograssProps extends BriefEventInfo {
  progressInfo: ObjectString;
  progressList: any[];
  advancedList: any[]; // 高级玩法
}
interface BriefEventInfo {
  eventInfo: EventInfo /** 0 非审核状态 1 审核中 2 审核失败 3 审核成功 */;
}
export type EventInfos = EventInfo;

const Store = createContext(initialState);

export const useStore = () => useContext(Store);
export enum ACTION {
  GETERRORLIST,
  UPDATEEEORLIST,
  UPDATEDATA,
  INITSTATE,
  UPDATEPROGRESSINFO,
  UPDATEINFOREEDIRTSTATUS,
  GetUserAuthority,
  GETPROGROGRESSCONFIGARRAY, // 获取主办方发布必填项配置
  RESET,
  UPDATECOVER, // 更新封面
  GETHOSTDETAIL, // 获取当前主办方信息
}
export interface ACTIONPROPS {
  type?: number;
  data?: any;
}

const reducer = (state: any, action: ACTIONPROPS) => ({ ...state, ...action.data });

const useErrorReducer = (eventId: any) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  let statusInterval: any = null;
  // asyncDispatch里面可能拿不到最新的 state
  const ref = useRef<any>(null);
  ref.current = state;

  const asyncDispatch = (action: ACTIONPROPS) => {
    if (action.type === ACTION.UPDATEDATA) {
      dispatch({ data: action.data });
      return;
    }
    if (action.type === ACTION.INITSTATE) {
      dispatch({ data: { ...initialState } });
      return;
    }
    if (action.type === ACTION.UPDATECOVER) {
      dispatch({ data: { coverInfo: action.data } });
      return;
    }
    // 获取报错中心错误列表
    if (action.type === ACTION.GETERRORLIST) {
      return GetPublishErrorList({ event_id: eventId }).then((res: any) => {
        if (res?.code === 0) {
          dispatch({
            data: { errorInfo: res?.data?.items, errorItemsSort: res?.data?.items_sort },
          });
        }
      });
    }
    // 更新当前操作数量
    if (action.type === ACTION.UPDATEEEORLIST) {
      const { data } = action;
      if (data?.id === '-1') {
        dispatch({ data: { showErrorCenter: true } });
        return;
      }
      const arr = [...state.errorInfo];
      arr.splice(data?.index, 1);
      dispatch({ data: { errorInfo: arr, showErrorCenter: false } });
      return DealWithPublishError({ event_id: eventId, error_type: data?.id }).then((res) => {
        if (res?.code !== 0) {
          asyncDispatch({ type: ACTION.GETERRORLIST });
        }
      });
    }
    // 更新当前活动审核状态
    if (action.type === ACTION.UPDATEINFOREEDIRTSTATUS) {
      return DashboardEventBriefInfo({ event_id: eventId }).then((res) => {
        if (res.code === 0 && res.data?.event_info) {
          const eventInfo = { ...res?.data?.event_info };
          const publishedEventInfo = res?.data?.published_event_info;
          dispatch({
            data: {
              eventInfo: action.data ? eventInfo : { ...eventInfo, reedit_status: 1 },
              publishedEventInfo,
            },
          });
          /**
           * 审核中活动=发布中
           * 修改审核中活动=修改发布中
           * */
          if (eventInfo?.status === 2 || eventInfo?.status === 4) {
            const personAudit = eventInfo?.is_person_audit;
            const plazaStatus = eventInfo?.plaza_status;
            const manualReview =
              personAudit === 1 && plazaStatus === 1 && ref.current?.loadingVisible;
            if (statusInterval) clearTimeout(statusInterval);
            // 当前为机器审核时轮询状态
            if (
              personAudit === 0 ||
              personAudit === 2 ||
              (personAudit === 1 && plazaStatus === 0) ||
              manualReview
            ) {
              statusInterval = setTimeout(
                () => {
                  clearTimeout(statusInterval);
                  asyncDispatch({
                    type: ACTION.UPDATEINFOREEDIRTSTATUS,
                    data: eventId,
                  });
                },
                manualReview ? 60000 : 3000,
              );
            }
          }
          /**
           * 当前活动发布失败
           * 审核失败状态
           * */
          if (eventInfo?.status === 3 || eventInfo?.status === 5) {
            asyncDispatch({ type: ACTION.GETERRORLIST });
          }
        }
      });
    }
    // 更新进度条数据
    if (action.type === ACTION.UPDATEPROGRESSINFO) {
      // 当前活动检查表配置优先取session里面
      return DashboardEventGetProgressOfModule({ event_id: eventId }).then((res) => {
        if (res?.code === 0 && res.data) {
          sessionStorage.setItem(
            `EventOverviewGetProgressOfCompletion_${eventId}`,
            JSON.stringify(res.data),
          );
          const data = { progressInfo: res.data };
          if (action.data?.accessRuleChange) Object.assign(data, { showPublishChangeDialog: true });
          console.log('submitChange', data);
          dispatch({ data });
        }
      });
    }
    // 获取用户权限
    if (action.type === ACTION.GetUserAuthority) {
      return LobbyUserGetUserAuthority({ event_id: eventId }).then((res: any) => {
        if (res?.code === 0) {
          dispatch({ data: { userAuthority: res?.data } });
        }
      });
    }
    // 获取该活动的检查表配置
    if (action.type === ACTION.GETPROGROGRESSCONFIGARRAY) {
      return DashboardEventGetModules({ event_id: eventId }).then((res: any) => {
        if (res?.code === 0) {
          sessionStorage.setItem(
            `EventOverviewGetModules_${eventId}`,
            JSON.stringify(res?.data?.module_list),
          );
          sessionStorage.setItem(
            `DashboardEventGetadvanced_${eventId}`,
            JSON.stringify(res?.data?.advanced_list),
          );
          dispatch({
            data: {
              progressList: res?.data?.module_list,
              advancedList: res?.data?.advanced_list,
            },
          });
        }
      });
    }
    // 清理定时器
    if (action.type === ACTION.RESET) {
      if (statusInterval) clearTimeout(statusInterval);
    }
    // 获取当前活动主办方信息
    if (action.type === ACTION.GETHOSTDETAIL) {
      const id = action.data;
      if (!id) return;
      return getHostDetail(id).then((res) => {
        dispatch({
          data: {
            hostDetail: res,
          },
        });
      });
    }
  };
  return [state, asyncDispatch];
};
interface IProps {
  children: ReactNode;
}
const StoreProvider: FC<IProps> = ({ children }) => {
  const router = useRouter();
  const { query } = router;
  const eventId = query?.eventid as string;
  const [state, dispatch] = useErrorReducer(eventId);

  const handleError = (id: string, index: number) => {
    const to = ErrorType(id, eventId);
    if (id === 'error_type_no_payment_qualification') {
      String(state?.userAuthority?.org_role_id) === ROLETYPE.CREATED
        ? window.open(`${location.origin}${to}`)
        : message.warning({ content: '请联系创建者处理' });
    } else if (id === 'error_type_canvas_info_censor_failed') {
      window.open(`${location.origin}${to}`);
    } else if (to) {
      router.push(`${location.origin}${to}`);
    }
    dispatch({ type: ACTION.UPDATEEEORLIST, data: { id, index } });
  };

  const closePublishTip = (showPublishTip: boolean, showCanPublishTip: boolean) => {
    if (showPublishTip) {
      localStorage.setItem(`showPublishTip${eventId}`, '3');
      dispatch({ type: ACTION.UPDATEDATA, data: { showPublishTip: false } });
    }
    if (showCanPublishTip) {
      localStorage.setItem(`showCanPublishTip${eventId}`, '2');
      dispatch({ type: ACTION.UPDATEDATA, data: { showCanPublishTip: false } });
    }
  };

  useEffect(() => {
    if (!eventId) return;
    // 如果当前sessin存在
    // 当前活动检查表配置优先取session里面
    // 当前活动检查表配置优先取session里面
    const proccesCompletedStr =
      sessionStorage.getItem(`EventOverviewGetProgressOfCompletion_${eventId}`) || '';
    const proccesListdStr = sessionStorage.getItem(`EventOverviewGetModules_${eventId}`) || '';
    const advanceListStr = sessionStorage.getItem(`DashboardEventGetadvanced_${eventId}`) || '';
    dispatch({
      type: ACTION.UPDATEDATA,
      data: {
        progressList: proccesListdStr ? JSON.parse(proccesListdStr) : defaultProgressList,
        progressInfo: proccesCompletedStr ? JSON.parse(proccesCompletedStr) : defaultProgressInfo,
        advancedList: advanceListStr ? JSON.parse(advanceListStr) : defaultAdvancedList,
      },
    });
    dispatch({ type: ACTION.GETPROGROGRESSCONFIGARRAY });
    dispatch({ type: ACTION.GETERRORLIST });
    dispatch({
      type: ACTION.UPDATEINFOREEDIRTSTATUS,
      data: eventId,
    });
    dispatch({ type: ACTION.GetUserAuthority });
    dispatch({ type: ACTION.UPDATEPROGRESSINFO });
    return () => dispatch({ type: ACTION.RESET });
  }, [eventId]);
  /** 信息获取成功后请求当前主办方信息 */
  useEffect(() => {
    if (!state?.eventInfo?.host_id) return;
    dispatch({
      type: ACTION.GETHOSTDETAIL,
      data: state?.eventInfo?.host_id,
    });
  }, [state?.eventInfo?.host_id]);
  useEffect(() => {
    // 首次二次编辑的时候出现提示
    if (state?.eventInfo?.is_first_publish && state?.eventInfo?.reedit_status === 0) {
      localStorage.setItem(`showPublishTip${eventId}`, '1');
    }
    if (
      localStorage.getItem(`showPublishTip${eventId}`) === '1' &&
      state?.eventInfo?.reedit_status === 1
    ) {
      localStorage.setItem(`showPublishTip${eventId}`, '2');
      dispatch({ type: ACTION.UPDATEDATA, data: { showPublishTip: true } });
    }
  }, [state?.eventInfo]);

  useEffect(() => {
    // 创建活动后跳转到管理页面显示 创建成功toast
    if (localStorage.getItem(`showToast${eventId}`) === '1') {
      localStorage.removeItem(`showToast${eventId}`);
      message.success({ content: '创建成功' });
    }
    // 如果没有点击知道了或发布按钮，刷新页面后还会显示
    if (localStorage.getItem(`showPublishTip${eventId}`) === '2') {
      dispatch({ type: ACTION.UPDATEDATA, data: { showPublishTip: true } });
    }
    if (localStorage.getItem(`showCanPublishTip${eventId}`) === '1') {
      dispatch({ type: ACTION.UPDATEDATA, data: { showCanPublishTip: true } });
    }
    // 每次切换到页面时触发一次刷新状态
    const visibilitychange = () => {
      if (document.visibilityState === 'hidden') return;
      dispatch({
        type: ACTION.UPDATEINFOREEDIRTSTATUS,
        data: 1,
      });
    };
    window.document.addEventListener('visibilitychange', visibilitychange);
    return () => {
      window.document.removeEventListener('visibilitychange', visibilitychange);
    };
  }, []);
  // 每次活动状态发生变更
  // 或存在二次发布内容时
  useEffect(() => {
    dispatch({
      type: ACTION.UPDATEPROGRESSINFO,
    });
  }, [state?.eventInfo?.status, state?.eventInfo?.reedit_status]);

  // 从活动列表跳转过来可能需要展开错误中心
  useEffect(() => {
    if (state?.errorInfo?.length && sessionStorage.getItem('showErrorModal')) {
      dispatch({ type: ACTION.UPDATEDATA, data: { showErrorCenter: true } });
      sessionStorage.setItem('showErrorModal', '');
    }
  }, [state?.errorInfo]);

  return (
    <Store.Provider
      value={{
        ...state,
        dispatch,
        handleError,
        closePublishTip,
      }}
    >
      {children}
    </Store.Provider>
  );
};

export default StoreProvider;
